import { Component, OnInit, Input } from "@angular/core";
import { UserStandingdataModel } from "@app/user/user-maintenance/shared/user-standingdata-model";
import { UserMaintenancePermissionModel } from "@models/permissions/UserMaintenancePermissionModel";
import { UserDetailModel } from "@app/user/user-maintenance/shared/user-detail-model";
import { Language } from "@app/user/user-profile/shared/language.enum";

@Component({
    selector: "user-info",
    templateUrl: "./user-info.component.html",
    styleUrls: ["./user-info.component.scss"],
    standalone: false
})
export class UserInfoComponent implements OnInit {
    @Input() user: UserDetailModel;
    @Input() sd: UserStandingdataModel;
    @Input() permissions: UserMaintenancePermissionModel;

    // "Use tenant default" is keyed as 0, not null: cerrix-select's writeValue treats a
    // null bindValue as "not defined" and refuses to select it. The Language enum has no
    // 0 member, so 0 is a safe sentinel; languageSelectValue converts to/from it.
    languageOptions: { ID: Language | 0; Name: string }[] = [
        { ID: 0, Name: "Use your Cerrix environment default" },
        { ID: Language.English, Name: "English" },
        { ID: Language.Dutch, Name: "Dutch" },
        { ID: Language.Norwegian, Name: "Norwegian" },
    ];

    constructor() {}

    ngOnInit() {}

    get languageSelectValue(): Language | 0 {
        return this.user.language ?? 0;
    }

    set languageSelectValue(value: Language | 0) {
        this.user.language = value || null;
    }
}
